<template>
  <div id="app-list">
    <div class="list-box">
      <ul>
        <li v-for="(item,index) in infoList" :key="index">
          <p>{{item.title}}</p>
          <span>{{item.time}}</span>
        </li>
      </ul>
      <div class="page-box">
        <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      infoList:[
        {
          id:1,
          title:'·2018年8月爱眼基金会善款收入 24,271,288.17元',
          time:'2018-12-30'
        },
        {
          id:1,
          title:'·2018年8月爱眼基金会善款收入 24,271,288.17元',
          time:'2018-12-30'
        },
        {
          id:1,
          title:'·2018年8月爱眼基金会善款收入 24,271,288.17元',
          time:'2018-12-30'
        },
        {
          id:1,
          title:'·2018年8月爱眼基金会善款收入 24,271,288.17元',
          time:'2018-12-30'
        },
        {
          id:1,
          title:'·2018年8月爱眼基金会善款收入 24,271,288.17元',
          time:'2018-12-30'
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
#app-list {
  width: 100%;
}
.list-box {
  width: 1300px;
  margin: 0 auto;
  > ul {
    margin: 40px 0 60px 0;
    > li {
      display: flex;
      justify-content: space-between;
      padding: 22px 40px 22px 26px;
      transition: ease-out 0.6s;
      cursor: pointer;
      &:hover{
        background-color: #c30d23;
        >p{
          color: #fff;
        }
        >span{
          color: #fff;
        }
      }
      > p {
        font-size: 16px;
        color: #333333;
        width: 65%
      }
      > span {
        font-size: 16px;
        color: #999999;
        width: 25%;
        text-align: right;
      }
    }
  }
  .page-box{
    text-align: center;
    margin-bottom: 70px;
  }
}
.page-box /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #c30d23;
  color: #fff;
}
.page-box /deep/ .el-pagination.is-background .el-pager li{
  background-color: #fff;
  border: solid 1px #dddddd;
  color: #999;
}
.page-box /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover{
  color: #c30d23;
}
</style>



// WEBPACK FOOTER //
// src/components/Info/info_list.vue